import React, { Component } from 'react';
import Spinner from '@cimpress/react-components/lib/shapes/Spinner';

export default class Loading extends Component {
  render() {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <Spinner />
      </div>
    );
  }
}
